import { render, staticRenderFns } from "./AllMyForms.vue?vue&type=template&id=1037a1b3&scoped=true&"
import script from "./AllMyForms.vue?vue&type=script&lang=js&"
export * from "./AllMyForms.vue?vue&type=script&lang=js&"
import style0 from "./AllMyForms.vue?vue&type=style&index=0&id=1037a1b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1037a1b3",
  null
  
)

export default component.exports